import api from '../api';

export const independentAnalyticsService = {
  getDashboard: async (params = {}) => {
    const response = await api.get('/independent/analytics/dashboard', { params });
    return response.data;
  },

  getRevenueTrends: async (params = {}) => {
    const response = await api.get('/independent/analytics/revenue-trend', { params });
    return response.data;
  },

  getQuoteConversion: async (params = {}) => {
    const response = await api.get('/independent/analytics/quote-conversion', { params });
    return response.data;
  },

  getClientDemographics: async (params = {}) => {
    const response = await api.get('/independent/analytics/client-demographics', { params });
    return response.data;
  },

  clearCache: async () => {
    const response = await api.delete('/independent/analytics/cache/clear');
    return response.data;
  }
};

export default independentAnalyticsService;
